<template>
  <!-- begin panel -->
  <panel
    no-button="true"
    v-bind:title="stage ? `Add new step to ${stage.name}` : `Create step`"
  >
    <p v-if="errors.length">Please correct the following error(s):</p>
    <ul>
      <li v-for="error in errors" :key="error" style="color: red">
        {{ error }}
      </li>
    </ul>
    <form>
      <div class="form-group row m-b-15">
        <label class="col-form-label col-md-3">Step name</label>
        <div class="col-md-9">
          <input
            v-model="name"
            type="text"
            class="form-control m-b-5"
            placeholder="Enter step name"
          />
        </div>
      </div>
      <div class="form-group row m-b-15" v-if="!stage">
        <label class="col-form-label col-md-3">Stage</label>
        <div class="col-md-9">
          <select v-model="stageId" class="form-control">
            <option :value="null">None</option>
            <option
              v-for="stage in filterStages(activeEvent.id)"
              :key="stage.id"
              :value="stage.id"
            >
              {{ stage.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="form-group row m-b-15">
        <label class="col-form-label col-md-3">Description</label>
        <div class="col-md-9">
          <textarea
            v-model="description"
            class="form-control"
            rows="3"
          ></textarea>
        </div>
      </div>
      <div class="form-group row m-b-15">
        <label class="col-form-label col-md-3">Insights</label>
        <div class="col-md-9">
          <textarea v-model="insights" class="form-control" rows="3"></textarea>
        </div>
      </div>
      <div class="form-group row m-b-15">
        <label class="col-form-label col-md-3">Target outcome</label>
        <div class="col-md-9">
          <textarea v-model="target" class="form-control" rows="3"></textarea>
        </div>
      </div>
      <div class="form-group row m-b-15">
        <label class="col-form-label col-md-3">
          Plan things you wish to provide here
        </label>
        <div class="col-md-9">
          <textarea v-model="plan" class="form-control" rows="3"></textarea>
        </div>
      </div>
      <div class="form-group row m-b-15">
        <label class="col-form-label col-md-3">Responsible person</label>
        <div class="col-md-9">
          <input
            v-model="responsiblePerson"
            type="text"
            class="form-control m-b-5"
            placeholder="Enter name"
          />
        </div>
      </div>
      <div class="form-group row m-b-15">
        <label class="col-form-label col-md-3">Production budget</label>
        <div class="col-md-9">
          <input
            v-model="budget"
            type="number"
            min="0"
            class="form-control m-b-5"
            placeholder="Enter estimated budget"
          />
        </div>
      </div>
      <div
        v-for="(note, index) in notes"
        :key="index"
        class="form-group row m-b-15"
      >
        <label class="col-form-label col-md-3">Note #{{ index + 1 }}</label>
        <div class="col-md-8">
          <textarea v-model="note.content" class="form-control" rows="3" />
        </div>
        <div class="col-md-1">
          <b-button @click="openModal(index)" class="btn-danger pull-right">
            Remove note
          </b-button>
        </div>
      </div>
      <div class="form-group row m-b-15">
        <div class="col-md-11" />
        <div class="col-md-1">
          <input-button
            type="button"
            label="Add note"
            @click="addNote"
            class="btn-inverse pull-right"
          />
        </div>
      </div>
      <div class="form-group row m-b-15">
        <label class="col-form-label col-md-3">Image</label>
        <div class="col-md-9">
          <vue-dropzone
            ref="imageDropzone"
            id="imageDropzone"
            :options="imageDropzoneOptions"
            @vdropzone-removed-file="imageRemoved"
            @vdropzone-success="imageSuccess"
          />
          <b-button variant="yellow" class="mt-2" @click="openImageLibrary">
            Choose from library
          </b-button>
        </div>
      </div>
      <div class="form-group row m-b-15">
        <label class="col-form-label col-md-3">Files</label>
        <div class="col-md-9">
          <vue-dropzone
            ref="filesDropzone"
            id="filesDropzone"
            :options="filesDropzoneOptions"
            @vdropzone-removed-file="fileRemoved"
            @vdropzone-success="fileSuccess"
          />
        </div>
      </div>
    </form>

    <hr />

    <b-button variant="secondary" @click="cancel">Cancel</b-button>
    <input-button
      type="submit"
      label="Save and create another"
      @click="validate(true)"
      class="btn-inverse pull-right"
    />
    <input-button
      type="submit"
      label="Save"
      @click="validate(false)"
      class="btn-yellow pull-right"
    />

    <b-modal
      ref="modalAlert"
      :title="'Delete Note #' + (currentIndex + 1)"
      centered
      cancel-variant="white"
      ok-variant="danger"
      ok-title="Delete"
      v-on:ok="removeNote(currentIndex)"
    >
      <div class="alert alert-danger m-b-0">
        <h5><i class="fa fa-info-circle"></i>Delete</h5>
        <p>Are you sure you want to delete Note #{{ currentIndex + 1 }}?</p>
      </div>
    </b-modal>

    <image-library-modal ref="childModal" />
  </panel>
  <!-- end panel -->
</template>

<script>
import InputButton from '../../components/buttons/InputButton.vue'
import ImageLibraryModal from '../image-library/ImageLibraryModal.vue'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { authHeader } from '../../helpers'

export default {
  name: 'StepCreate',
  props: ['stage', 'storyboards', 'stages', 'activeEvent'],
  components: {
    InputButton,
    ImageLibraryModal,
    VueDropzone: vue2Dropzone
  },
  data() {
    return {
      errors: [],
      currentIndex: 0,
      name: '',
      stageId: null,
      description: '',
      insights: '',
      target: '',
      plan: '',
      responsiblePerson: '',
      budget: 0,
      notes: [],
      imageId: null,
      fileIds: [],
      dropzoneArray: [],
      imageDropzoneOptions: {
        url: process.env.VUE_APP_API_URL + '/image',
        thumbnailWidth: 175,
        addRemoveLinks: true,
        maxFiles: 1,
        maxFilesize: 2,
        acceptedFiles: 'image/jpg, image/jpeg, image/png',
        dictDefaultMessage: 'Drop an image here to upload',
        headers: authHeader()
      },
      filesDropzoneOptions: {
        url: process.env.VUE_APP_API_URL + '/file',
        thumbnailWidth: 175,
        addRemoveLinks: true,
        maxFilesize: 5,
        acceptedFiles: 'application/pdf, image/jpg, image/jpeg',
        dictDefaultMessage: 'Drop files here or click to upload',
        headers: authHeader()
      },
      isDestroying: false
    }
  },
  methods: {
    validate(createAnother) {
      if (this.description == null) {
        this.description = ''
      }
      if (this.insights == null) {
        this.insights = ''
      }
      if (this.target == null) {
        this.target = ''
      }
      if (this.plan == null) {
        this.plan = ''
      }
      if (this.responsiblePerson == null) {
        this.responsiblePerson = ''
      }
      if (this.budget == null) {
        this.budget = 0
      }

      if (this.name) {
        this.submit(createAnother)
      }

      this.errors = []

      if (!this.name) {
        this.errors.push('Name required!')
      }
    },
    async submit(createAnother) {
      if (this.$route.params.id) {
        await this.$parent.$parent.stepCreate(
          JSON.stringify({
            stage: this.$route.params.stageId,
            name: this.name,
            description: this.description,
            insights: this.insights,
            target: this.target,
            plan: this.plan,
            responsiblePerson: this.responsiblePerson,
            budget: this.budget,
            notes: this.notes,
            imageId: this.imageId,
            fileIds: this.fileIds,
            eventId: parseInt(this.activeEvent.id)
          }),
          createAnother
        )
      } else {
        await this.$parent.stepCreate(
          JSON.stringify({
            stage: this.stageId,
            name: this.name,
            description: this.description,
            insights: this.insights,
            target: this.target,
            plan: this.plan,
            responsiblePerson: this.responsiblePerson,
            budget: this.budget,
            notes: this.notes,
            imageId: this.imageId,
            fileIds: this.fileIds,
            eventId: parseInt(this.activeEvent.id)
          }),
          createAnother
        )
      }
    },
    filterStages(event) {
      let filteredStages = []
      let storyboards = this.storyboards.filter(function (sb) {
        return sb.event == event
      })
      storyboards.forEach((sb) => {
        sb.stages.forEach((stage) => {
          filteredStages.push(stage)
        })
      })
      return filteredStages
    },
    addNote() {
      this.notes.push({ content: '' })
    },
    openModal(index) {
      this.currentIndex = index
      this.$refs['modalAlert'].show()
    },
    removeNote(index) {
      this.notes.splice(index, 1)
    },
    imageRemoved() {
      if (!this.isDestroying) {
        this.$parent.removeImage(this.imageId)
        this.imageId = null
      }
    },
    imageSuccess(imageFile, image) {
      this.imageId = image.id
    },
    imageSelected(image) {
      this.$refs.imageDropzone.removeAllFiles()
      this.imageId = image.id

      let mockFile = {
        id: this.imageId,
        size: 175,
        url: process.env.VUE_APP_API_URL + '/uploads/images/' + image.imageFd
      }
      this.$refs.imageDropzone.manuallyAddFile(mockFile, mockFile.url)
    },
    openImageLibrary() {
      this.$refs['childModal'].$refs['modalImageLibrary'].show()
    },
    cancel() {
      if (this.imageId) {
        this.$parent.removeImage(this.imageId)
      }
      if (this.fileIds.length) {
        this.fileIds.forEach((fileId) => {
          this.$parent.removeFile(fileId)
        })
      }
      this.$router.push('/storyboard/search/steps')
    },
    fileRemoved(file) {
      if (!this.isDestroying) {
        let index = 0
        this.dropzoneArray.forEach(function (obj, objIndex) {
          if (file.upload.uuid == obj.upload.uuid) {
            index = objIndex
          }
        })
        this.dropzoneArray = this.$refs.filesDropzone.dropzone.files
        this.$parent.$parent.removeFile(this.fileIds[index])
        this.fileIds.splice(index, 1)
      }
    },
    fileSuccess(fileFile, file) {
      this.fileIds.push(file.id)
      this.dropzoneArray = this.$refs.filesDropzone.dropzone.files
    }
  },
  beforeDestroy() {
    this.isDestroying = true
  }
}
</script>
